export enum ConfirmPurchaseType {
    CONFIRM_UPDATED = 'CONFIRM_UPDATED',
    CONFIRM_ALL = 'CONFIRM_ALL',
}
